import React from 'react';

import { BoxedDiv } from 'psims/react/components/layout';
import { UseMsoRefData } from 'psims/react/pages/primary-pages/data-submissions/mso/shared/use-mso-ref-data';
import { UseMsoRefinerAPI } from './use-mso-refiner-api';
import MsoStockholdingEditor from '../shared/mso-stockholding-editor';
import MsoStockOnBehalfEditor from '../shared/mso-stock-on-behalf-editor';
import MsoSummaryEditor from '../shared/mso-summary-editor';
import { OrganisationMsoSetting } from 'psims/models/submission-types/mso/organisation-mso-setting';
import Textarea from 'psims/react/components/textarea';
import { asString } from 'psims/lib/string';
import { UseMsoRefinerForm } from './use-mso-refiner-form';
import { UseMsoRefinerValidation } from './use-mso-refiner-validation';
import { UseMsoRefinerValidationAlerts } from './use-mso-refiner-validation-alerts';
import { UseMsoRefinerFocus } from './use-mso-refiner';
import { UseConfirm } from '../../shared/use-confirm';
import MsoHeldAtRefineryEditor from '../shared/mso-held-at-refinery-editor';
import { UseMsoRefinerNavigation } from './use-mso-refiner-navigation';
import { UsePortalData } from '../../shared/use-portal-data';

interface MsoRefinerDataEditorProps {
    apiCtrl: PopulatedProps<UseMsoRefinerAPI, 'submission'>;
    deleteCtrl: UseConfirm;
    focusedFieldCtrl: UseMsoRefinerFocus;
    formCtrl: UseMsoRefinerForm;
    isDisabled: boolean;
    navCtrl: UseMsoRefinerNavigation;
    portalDataCtrl: UsePortalData;
    refData: UseMsoRefData;
    validationCtrl: UseMsoRefinerValidation;
    validationAlertsCtrl: UseMsoRefinerValidationAlerts;
    
}
//
const MsoRefinerDataEditor = ({
    apiCtrl,
    deleteCtrl,
    focusedFieldCtrl,
    formCtrl,
    isDisabled,
    navCtrl,
    portalDataCtrl,
    refData,
    validationCtrl,
    validationAlertsCtrl,
    
}: MsoRefinerDataEditorProps) => {
    return (
        <BoxedDiv box={{}}>
            <MsoStockholdingEditor
                actions={formCtrl}
                datasubmission={apiCtrl.submission.dataSubmission}
                deleteCtrl={deleteCtrl}
                focusedField={focusedFieldCtrl.focusedField}
                hideEEZ={true}
                isDisabled={isDisabled}
                msoTypeLabel='Refiner'
                portalData={portalDataCtrl}
                refData={refData}
                saveAttempted={navCtrl.lastSaveAttemptIndex === 0}
                stockholdings={validationCtrl.stockholdings || []}
            />

            <MsoHeldAtRefineryEditor
                actions={formCtrl}
                dataSubmission={apiCtrl.submission.dataSubmission}
                focusedField={focusedFieldCtrl.focusedField}
                isDisabled={isDisabled}
                saveAttempted={navCtrl.lastSaveAttemptIndex === 0}
                refData={refData}
                stockRefineriesHeld={validationCtrl.stockRefineriesHeld as []}
            />

            <MsoStockOnBehalfEditor
                actions={formCtrl}
                deleteCtrl={deleteCtrl}
                focusedField={focusedFieldCtrl.focusedField}
                isDisabled={isDisabled}
                portalData={portalDataCtrl}
                refData={refData}
                saveAttempted={navCtrl.lastSaveAttemptIndex === 0}
                stocksOnBehalf={validationCtrl.stocksOnBehalf || []} 
                datasubmission={apiCtrl.submission.dataSubmission}                //dataSubmission={dataSubmission}
            />
        
            <MsoSummaryEditor
                actions={formCtrl}
                focusedField={focusedFieldCtrl.focusedField}
                isDisabled={isDisabled}
                msoSettings={apiCtrl.submission.msoSettings as Array<OrganisationMsoSetting>}
                msos={validationCtrl.msos || []}
                portalData={portalDataCtrl}
                refData={refData}
                msoTypeName={'refiner'}
                saveAttempted={navCtrl.lastSaveAttemptIndex === 0}
                validationAlerts={validationAlertsCtrl.filter(va => va.tooltip.target.entity === 'mso')}
            />

            {/* Comments */}
            <BoxedDiv box={{}}>
                <Textarea
                    disabled={isDisabled}
                    error={validationCtrl.msoComment?.validationMessages.comments?.tooltip.message}
                    id='comments'
                    label='Comments'
                    onChange={e => formCtrl.updateComments(e.target.value)}
                    setFocused={focusedFieldCtrl.focusedField?.kind === 'comments'}
                    value={asString(formCtrl.submissionUpdate.msoComment?.comments)}
                />
            </BoxedDiv>
        </BoxedDiv>
    );
}

export default MsoRefinerDataEditor;
